import { useAuth0 } from "@auth0/auth0-react";
//@ts-expect-error upstream _says_ this is a type
import Brainfish from "@brainfish-ai/web-widget";
import { type FC, useEffect, useState } from "react";
import { useAnalyticsData } from "../analytics/hooks/use-analytics-data";
import { useClaims } from "../generic/hooks/use-claims";
import "./brainfish.css";
import { useBrainfish } from "./use-brainfish";

export const BrainFish: FC = () => {
  const { loading: brainfishLoading, widgetKey } = useBrainfish();

  const [initialized, setInitialized] = useState(false);
  const { user } = useAuth0();
  const claims = useClaims();
  const { data, loading } = useAnalyticsData(claims?.sub, claims?.role, user?.email);

  useEffect(() => {
    if (brainfishLoading || !widgetKey) return;

    void Brainfish.Widgets.init({ widgetKey }).then(() => {
      setInitialized(true);
    });
  }, [widgetKey, brainfishLoading]);

  useEffect(() => {
    if (loading || !data || !initialized) return;

    Brainfish.Widgets.identify({
      userId: claims?.sub,
      email: data.visitor.auth0Email,
      teamId: data.account.id,
      subscription: claims?.role,
    });
  }, [data, loading, initialized, claims?.sub, claims?.role]);

  return null;
};
